/** @deprecated please use fazzBizzThemeFds3 colors theme instead */
export enum BLACK {
  DEFAULT = '#1B2736',
  T10 = '#2C4058',
  T20 = '#3E597A',
  T30 = '#4F719C',
}
